<template>
  <div class="cog-layout">
    <aside :class="['cog-sidebar-shell', showclass]">
      <leftnav />
    </aside>
    <div class="cog-main-shell">
      <header class="cog-header">
        <navcon />
      </header>
      <main class="cog-page-shell">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'

export default {
  name: 'index',
  components: {
    navcon,
    leftnav
  },
  data() {
    return {
      showclass: 'expanded'
    }
  },
  created() {
    this.$root.Bus.$on('toggle', value => {
      this.showclass = value ? 'expanded' : 'collapsed'
    })
  }
}
</script>

<style>
.cog-layout {
  display: flex;
  min-height: 100vh;
  background: var(--cog-bg);
}

.cog-sidebar-shell {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  transition: width var(--cog-transition);
}

.cog-sidebar-shell.expanded {
  width: 248px;
}

.cog-sidebar-shell.collapsed {
  width: 88px;
}

.cog-main-shell {
  flex: 1;
  min-width: 0;
  margin-left: 248px;
  transition: margin-left var(--cog-transition);
}

.cog-sidebar-shell.collapsed + .cog-main-shell {
  margin-left: 88px;
}

.cog-header {
  position: sticky;
  top: 0;
  z-index: 80;
  padding: 18px 24px 0;
  background: var(--cog-bg);
}

.cog-page-shell {
  padding: 20px 24px 24px;
}

@media (max-width: 1200px) {
  .cog-sidebar-shell.expanded {
    width: 224px;
  }

  .cog-main-shell {
    margin-left: 224px;
  }
}

@media (max-width: 768px) {
  .cog-sidebar-shell,
  .cog-sidebar-shell.collapsed,
  .cog-sidebar-shell.expanded {
    width: 88px;
  }

  .cog-main-shell,
  .cog-sidebar-shell.collapsed + .cog-main-shell,
  .cog-sidebar-shell.expanded + .cog-main-shell {
    margin-left: 88px;
  }

  .cog-header {
    padding: 16px 16px 0;
  }

  .cog-page-shell {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue